/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import Image from './../../../../../components/ZUILib/Image';
import commonUtil from '../../../../../utils/commonUtil';
import { handleClickItemDataLayer } from './dataLayerListWap';

class ListItemWap extends Component {
  handleClick = (itemData, categoryName, index) => {
    handleClickItemDataLayer({ eventId: this.props.eventId, itemData, categoryName, index });
    this.props.showContentWap(itemData, categoryName, index);
  };

  render() {
    this.categoryInfo = this.props.categoryInfo;
    const labels = this.props.labels;

    const categoryItemInfo = (itemData, index, categoryName) => {
      const productImageSrc = [
        {
          media: '(max-width: 465px)',
          srcSet: itemData.imageURL,
        },
      ];

      if (categoryName === commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label')) {
        this.defaultImage = commonUtil.getAssetURL() + '/images/certificado.jpg';
      } else {
        this.defaultImage = commonUtil.getAssetURL() + '/images/guest/no-image.png';
      }

      const productImageAttribute = {
        id: 'img1',
        alt: 'Liverpool',
        src: itemData.imageURL,
        altImg: itemData?.altImageUrl || this.defaultImage,
        style: { width: '164px' },
        pictureHtmlStyle: {
          heightPicture: '228px',
          flexPicture: 'flex',
          alignPicture: 'center',
        },
      };

      return (
        <React.Fragment>
          {
            (
              <div
                style={{ width: '50%', display: 'flex', flexDirection: 'column' , position:"relative"}}
                className={`product_${index}`} onClick={() => this.handleClick(itemData, categoryName, index)}
              >
                <div>
                  <Image imageAttr={productImageAttribute} _imgsrc={productImageSrc} key={index} />
                </div>
                <div className='productInfo_wap'>
                  <h4
                    className="titleProduct_wap"
                    style={{
                      fontSize: 12,
                      color: '#333',
                      fontWeight: 400,
                      lineHeight: "15.6px",
                      letterSpacing: 0.2,
                      marginBottom:'4px'
                    }}
                  >{itemData.name}</h4>
                  <span className='sku_id_listHead'>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.sku.label')}  <span className='sku_id_listitem'>{itemData && itemData.skuId || ''}</span></span>
                   <p
                    className="quantityProduct_wap"
                   
                  >
                    {commonUtil.getLabel(labels.GuestviewPage, 'guestview.quantity.label')}
                    <span className='product_quantity-wap'>{itemData.quantity}</span>
                  </p>
                  {
                    Number(itemData.salePrice) < Number(itemData.listPrice) &&
                    categoryName !== commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label')
                      ?
                        <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                          <p
                            className="salePrice"
                            dangerouslySetInnerHTML={{ __html: commonUtil.getHtmlCurrency(itemData.listPrice) }}
                          />
                          <p className="priceProduct" dangerouslySetInnerHTML={{ __html: commonUtil.getHtmlCurrency(itemData.salePrice) }} />
                        </div>
                      :
                        <p
                          className="priceProduct"
                          dangerouslySetInnerHTML={{ __html: commonUtil.getHtmlCurrency(itemData.listPrice) }}
                        />
                  }
                
                  {
                    itemData.isFavourite
                      ? <img src={commonUtil.getAssetURL() + '/images/starrr.svg'} className="star_rating_listitem" />
                      : ''
                  }
                </div>
              </div>
            )
          }
        </React.Fragment>
      );
    };

    return (
      <React.Fragment>
        { categoryItemInfo(this.categoryInfo, this.props.index, this.categoryInfo.categoryName) }
      </React.Fragment>
    );
  }
}

export default ListItemWap;
